import {z} from 'zod';

export const WarehouseSpaceFormSchema = z.object({
  isActive: z.boolean(),
  name: z.string(),
  assignWarehouses: z.array(z.string()),
});

export type WarehouseSpaceForm = z.infer<typeof WarehouseSpaceFormSchema>;
